<script setup>
import { home } from '@/actions/App/Http/Controllers/PageController'
import AppLayout from '@/Layouts/AppLayout.vue'
import {
    AboutSection,
    ContactSection,
    FaqSection,
    HeroSection,
    ProjectSection,
    ServiceSection,
} from '@/Pages/Home/Partials'

defineProps({
    projects: {
        type: Array,
        required: true,
    },

    demand_types: {
        type: Array,
        required: true,
    },

    demand_of_constructions: {
        type: Array,
        required: true,
    },
})
</script>

<template>
    <AppLayout
        meta_title="Montáž sádrokartonu, foukaná izolace a betonové stěrky"
        meta_description="Montujeme sádrokartony, foukáme izolace a aplikujeme betonové stěrky v Olomouckém kraji. Kvalitní práce od profesionálů."
        :meta_canonical="home.url()"
    >
        <template #content>
            <HeroSection />

            <section class="section-width space-y-12 lg:space-y-28">
                <ProjectSection :projects="projects" />

                <AboutSection />

                <ServiceSection />

                <ContactSection
                    :demand_types="demand_types"
                    :demand_of_constructions="demand_of_constructions"
                />

                <FaqSection :show_faqs="['vyhody-supafil', 'technicke-parametry']" />
            </section>
        </template>
    </AppLayout>
</template>
